import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.component.html',
    styleUrls: ['./cookies.component.css'],
    standalone: false
})
export class CookiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
